import { useEffect, useMemo, useState } from 'react';
import { getCurrencyIconUrl } from '../../../assets/utils/currencyIcon';

function CurrencyIcon({
  className = '',
  code = '',
  currency,
  imageClassName = '',
  src = '',
}) {
  const iconUrl = useMemo(
    () => src || getCurrencyIconUrl(currency),
    [currency, src]
  );
  const [hasImageError, setHasImageError] = useState(false);

  useEffect(() => {
    setHasImageError(false);
  }, [iconUrl]);

  const shouldShowImage = Boolean(iconUrl && !hasImageError);
  const baseClassName = String(className || '').trim().split(/\s+/)[0];
  const rootClassName = [
    className,
    baseClassName && !shouldShowImage && `${baseClassName}--fallback`,
  ].filter(Boolean).join(' ');

  return (
    <span className={rootClassName} aria-hidden="true">
      {shouldShowImage ? (
        <img
          className={imageClassName}
          src={iconUrl}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setHasImageError(true)}
        />
      ) : (
        String(code || '$').slice(0, 1).toUpperCase()
      )}
    </span>
  );
}

export default CurrencyIcon;
